"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const T2 = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2967_12434)" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M20.9335 12.0205C20.9335 11.476 20.5705 11.08 19.9765 11.08C19.3495 11.08 19.0195 11.542 18.9865 12.0865H16.2475C16.4455 10.2055 17.815 8.704 19.9765 8.704C22.204 8.704 23.6065 9.9745 23.6065 11.8555C23.6065 13.159 22.6825 14.083 21.6595 15.073L19.993 16.723H23.6395V19H16.297V17.3005L19.7785 13.8355C20.4715 13.126 20.9335 12.6145 20.9335 12.0205Z",
        fill: "currentcolor"
      }
    ), /* @__PURE__ */ React.createElement("path", { d: "M3.624 6.952V4.264H16.2V6.952H11.448V19H8.352V6.952H3.624Z", fill: "currentcolor" })),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2967_12434" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" })))
  );
};
export default T2;
